import axios from 'axios';
import { API_URL, API_CORE_URL } from '../constantes/constantes';

/**
 * Obtiene los datos para el calendario del home desde un endpoint específico.
 *
 * @param {Object} params
 * @param {string} params.endpoint - URL completa del JSON a consumir.
 * @param {string} params.version - Versión del país ('us' o por defecto)
 * @returns {Promise<{ data: any, statusCode: number }>}
 */
export async function getEvents({ endpoint, version: country }) {
  const url = `${API_CORE_URL}${endpoint}`;
  
  try {
    const { data, status } = await axios.get(url, {
      timeout: 25000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json; charset=utf-8',
      },
      params: {
        ...(country === 'us' && { country }),
      },
    });

    return { statusCode: status, data };
  } catch (error) {
    console.error('Error en la petición:', error.message || error);

    const status = error.response?.status || 500;
    return { statusCode: status, data: [] };
  }
}